<script setup>
import {inject} from 'vue'

const contentData = inject('contentData')
</script>

<template>
    <section class="bg-gray-50 py-8 sm:py-10">
        <div class="container mx-auto px-4 text-center sm:px-6 sm:text-left">
            <span class="block text-sm leading-6 text-gray-600 sm:text-base">{{ contentData.text_footer }}</span>
            <p></p>
        </div>
    </section>
</template>

<style scoped></style>
